<template>
  <div class="w-full lg:flex-1">
    <div class="sky__product-breadcrumb-wrapper big-container">
      <breadcrumb
        :value="breadcrumb"
        no-enriched
      />
    </div>
    <div class="flex flex-col items-center lg:items-stretch lg:flex-row lg:flex-wrap justify-center">
      <div class="sky__product-screen-secondary-images-wrapper">
        <div class="sky__product-screen-secondary-images">
          <div
            v-if="product.cover"
            class="sky__secondary-image overflow-hidden cursor-pointer"
            :class="forceSecondaryImage === null ? 'selected' : null"
            :style="{
              backgroundImage: product.properties.background ? `url(${product.properties.background}?resize=true&width=1200&height=1200&format=webp)` : undefined,
              backgroundSize: 'cover'
            }"
            @click="forceSecondaryImage = null"
          >
            <img
              class=""
              :src="$helpers.makeCdnUrl(product.cover, product.slug, 'c', 't')"
              :alt="product.label"
              width="200"
              height="200"
              loading="lazy"
            >
          </div>
          <div
            v-for="(i, sIndex) in secondaryImages"
            :key="i.text_value"
            class="sky__secondary-image overflow-hidden cursor-pointer"
            :class="forceSecondaryImage === sIndex ? 'selected' : null"
            @click="forceSecondaryImage = sIndex"
            @mouseenter="() => {
              if ($store.state.screen.width > 900) {
                secondaryImageToDisplay = sIndex
              }
            }"
            @mouseleave="() => {
              if ($store.state.screen.width > 900) {
                secondaryImageToDisplay = null
              }
            }"
          >
            <img
              class=""
              :src="$helpers.makeCdnUrl(i, product.slug, sIndex, 't')"
              :alt="product.label"
              width="200"
              height="200"
              loading="lazy"
            >
          </div>
        </div>
      </div>
      <div
        class="order-first lg:order-none relative flex flex-col-reverse flex-1 justify-center"
      >
        <div
          :class="{
            'bg-sky_grey_darker': !product.properties.backroundIsDark,
            'bg-sky_blue': product.properties.backroundIsDark
          }"
          :style="{
            backgroundImage: product.properties.background ? `url(${product.properties.background}?resize=true&width=1200&height=1200&format=webp)` : undefined,
            backgroundSize: 'cover',
            width: '100%',
          // maxWidth: '855px'
          }"
          class="relative"
        >
          <div class="hidden md:block">
            <img
              v-if="coverToDisplay('b')"
              class="sky__product-screen-main-img mw-full mx-auto relative z-1"
              :src="coverToDisplay('b')"
              :alt="product.label"
              width="1000"
              height="1000"
            >
          </div>
          <div class="md:hidden">
            <img
              v-if="coverToDisplay('m')"
              class="sky__product-screen-main-img mw-full mx-auto relative z-1"
              :src="coverToDisplay('m')"
              :alt="product.label"
              width="500"
              height="500"
            >
          </div>
        </div>
        <div
          v-if="headband"
          class="sky__product-screen-headband"
          :style="{
            backgroundColor: headband.color,
            color: 'white'
          }"
        >
          {{ headband.text }}
        </div>
        <div
          v-if="discountPercentage"
          class="sky__product-screen-discount-percentage"
          style=""
        >
          -{{ discountPercentage }}%
        </div>
        <div class="sky__product-screen-wishlist-button">
          <wishlist-button :sku="product.sku" />
        </div>
        <div class="sky__product-screen-desktop-breadcrumb">
          <breadcrumb
            :value="breadcrumb"
            :dark="product.properties.backgroundIsDark"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '../general/Breadcrumb'
import WishlistButton from '../reusable/WishlistButton'

export default {
  components: {
    Breadcrumb,
    WishlistButton
  },
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      isMainImageLoaded: false,
      secondaryImageToDisplay: null,
      forceSecondaryImage: null
    }
  },
  computed: {
    headband () {
      return this.product.properties.headband
    },
    secondaryImages () {
      return this.product.properties.secondaryPictures
    },
    discountPercentage () {
      if (!this.product.pricing) {
        return null
      }
      const percentage = (this.product.pricing.crossed_taxed_price - this.product.pricing.unit_taxed_price) / this.product.pricing.crossed_taxed_price * 100
      return Math.ceil(percentage) || null
    },
    coverToDisplay () {
      return (size) => {
        const cover = this.product.cover
        if (this.secondaryImageToDisplay !== null) {
          return this.$helpers.makeCdnUrl(this.secondaryImages[this.secondaryImageToDisplay], this.product.slug, this.secondaryImageToDisplay, size)
        }
        if (this.forceSecondaryImage !== null) {
          return this.$helpers.makeCdnUrl(this.secondaryImages[this.forceSecondaryImage], this.product.slug, this.forceSecondaryImage, size)
        }
        if (!cover) {
          return null
        }

        return this.$helpers.makeCdnUrl(this.product.cover, this.product.slug, 'c', size)
      }
    },
    breadcrumb () {
      const breadcrumb = [
        ...this.product.hierarchy.map((hierarchy) => {
          return {
            text: hierarchy.label,
            to: this.$helpers.makeUri(hierarchy.path, 'category')
          }
        }),
        {
          text: this.product.properties.breadcrumb || this.product.label,
          to: this.$helpers.makeUri(this.product.path),
          disabled: true
        }
      ]

      return breadcrumb
    }
  }
}
</script>

<style lang="scss" scoped>
  .sky__product-screen-discount-percentage {
    @apply absolute font-funny bg-sky_orange text-white text-xl rounded-full px-2 py-2;
    bottom: 20px;
    right: 20px;
  }
  .sky__product-screen-headband {
    @apply absolute font-funny text-xl px-3 pb-0 pt-1 font-thin;
    top: 40px;
    left: 0;
  }
  .sky__product-screen-wishlist-button {
    @apply absolute;
    right: 20px;
    top: 20px;
  }
  .sky__product-screen-desktop-breadcrumb {
    @apply hidden;
    @screen lg {
      @apply block absolute;
      top: 10px;
      left: 10px;
    }
  }
  .sky__product-screen-secondary-images-wrapper {
    @screen lg {
      @apply mr-4;
      width: 130px;
      position: relative;
    }
    .sky__product-screen-secondary-images {
      @apply flex flex-wrap justify-center;
      @screen lg {
        @apply block absolute top-0 left-0 right-0 bottom-0 overflow-auto justify-start;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
  .sky__product-screen-main-img {
    // opacity: 0;
    // transition-duration: 0.3s;
    // &.loaded {
    //   opacity: 1;
    // }
  }
  .sky__secondary-image {
    @apply mb-4 mr-1 mt-3;
    width: 50px;
    height: 50px;
    border-radius: 50px;
    &.selected {
      @apply border-sky_secondary border-2;
    }
    @screen lg {
      border-radius: 0;
      width: 130px;
      height: 130px;
      @apply mr-0 mt-0;
    }
  }
  .sky__product-breadcrumb-wrapper {
    @apply mx-auto p-2 hidden;
  }
</style>
